import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ProgressService} from "./progress.service";
import {FacebookLogin, FacebookLoginResponse} from '@capacitor-community/facebook-login';
import * as _ from "lodash";
import {HybridToolsService} from './hybrid-tools.service';
import FacebookPlugin from '../../plugins/facebook.plugin';

declare var FB: any;

@Injectable()
export class FacebookService {
    constructor(
        private http: HttpClient,
        private progressService: ProgressService,
        private hybridToolsService: HybridToolsService
    ) {}


    getUserPermissions(userAccessToken) {
        this.progressService.startProgress(false);
        let headers = new HttpHeaders();
        if (userAccessToken) {
            headers = headers.set('accessToken', userAccessToken);
        }
        return this.http.get('/api/v1/facebook/me/permissions', {
            headers: headers
        });
    }

    async login(params: any = {}) {
        let result: any;
        let errResult: any;

        let options = this.getLoginOptions(params);

        result = await FacebookLogin.login(options).catch((err) => {
            errResult = err;
        });

        if (errResult) {
            result = errResult;
        }

        console.log(result);
        return !!(result?.accessToken?.token);
    }

    async logout() {
        await FacebookLogin.logout();
    }

    async getProfile() {
        const result: any = await FacebookLogin.getProfile({ fields: ['email'] });
        console.log(result);
        return result;
    }

    async getAccessToken() {
        let result: any;
        let errResult: any;

        result = await FacebookLogin.getCurrentAccessToken().catch((err) => {
            errResult = err;
        });

        if (errResult) {
            result = errResult;
        }

        console.log(result);
        return result
    }

    async hasPermission(permission: String) {
        const result: FacebookLoginResponse = await this.getAccessToken();

        if (result.accessToken.userId) {
            const permissions: any = await this.getPermissionsInternal(result.accessToken.userId);
            console.log(permissions);

            return _.some(permissions.data, function (item) {
                return item['permission'] === permission && item['status'] === 'granted';
            });
        } else {
            return false;
        }
    }

    private getLoginOptions(params: any = {}) {

        if (!_.has(params, 'permissions')) {
            params.permissions = [];
        }

        //need to explicitly request e-mail
        params.permissions = _.union(params.permissions, ['email']);

        return { permissions: params.permissions };
    }

    private async getPermissionsInternal<T extends object>(userId: string): Promise<T> {

        if (this.hybridToolsService.isMobileApp() && this.hybridToolsService.isAndroid()) {
            return new Promise<T>((resolve, reject) => {
                const result: any = FacebookPlugin.getPermissions({"userId": userId});
                resolve(<T>result);
            });
        } else if (this.hybridToolsService.isMobileApp() && (this.hybridToolsService.isIOS() || this.hybridToolsService.isIPadOS())) {
            return new Promise<T>((resolve, reject) => {
                const result: any = FacebookPlugin.getPermissions({"userId": userId});
                resolve(<T>result);
            });
        } else {
            return new Promise<T>((resolve, reject) => {
                FB.api(
                    `/${userId}/permissions`,
                    response => {
                        if (response.error) {
                            reject(response.error.message);

                            return;
                        }

                        resolve(<T>response);
                    },
                );
            });
        }
    }

    //ugh, the problem with the async login call above is that safari treats the pop-ups as unwanted
    syncLogin(params: any = {}, callback) {

        let options = this.getLoginOptions(params);

        FB.login(
            response => {
                console.debug('FB.login', response);
                let accessToken = {
                    accessToken: {
                        token: ( response.status === 'connected'? response.authResponse.accessToken : null)
                    },
                }
                callback(accessToken);
            },
            { scope: options.permissions.join(',') },
        );
    }

    syncLogout(callback) {
        FB.logout(callback());
    }

    syncGetAccessToken(callback) {

        FB.getLoginStatus(response => {

            let accessToken = {
                accessToken: {
                    token: ( response.status === 'connected'? response.authResponse.accessToken : null),
                    userId: ( response.status === 'connected'? response.authResponse.userID : null)
                },
            }

            callback(accessToken);
        });
    }

    syncHasPermission(permission: String, callback) {

        this.syncGetAccessToken((result) => {

            if (result?.accessToken?.userId) {

                let userId = result.accessToken.userId

                FB.api(
                    `/${userId}/permissions`,
                    response => {
                        console.log(response);

                        if (response.error) {
                            callback(false);
                        } else {
                            callback(
                                _.some(response.data, function (item) {
                                    return item['permission'] === permission && item['status'] === 'granted';
                                })
                            );
                        }
                    },
                );
            } else {
                callback(false);
            }
        });
    }
}
